import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IPermCandidateListShortlistClickedPayload {
  postingId: string;
  isShortlisted: boolean; // Value of intent - toggling on = true, represents final state
}

/**
 * Fires when user clicks the shortlist toggle for a candidate
 * Event: dental_portal:perm_candidate_list:shortlist_clicked
 */
export function firePermCandidateListShortlistClicked(
  payload: IPermCandidateListShortlistClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_candidate_list:shortlist_clicked', {
    posting_id: payload.postingId,
    is_shortlisted: payload.isShortlisted,
  });
}